import { Image } from "react-bootstrap";
import { MainCol, MainContainer, MainRow } from "../mainStyle/mainStyle";
import {
  BottomLinks,
  BottomLinksWrapper,
  FooterImgWrapper,
  FooterLinks,
  FooterLinksHeader,
  FooterWrapper,
  LeftDivText,
  LinksDiv,
  LinksWrapper,
  PresaleBtn,
  SocialIconHolder,
  SocialIconsWrapper,
} from "./element";
import { bluelogo, cnb, fau, footerlogo } from "assets";
import {
  FaTelegramPlane,
  FaYoutube,
  FaFacebookF,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";
import { DarkButton } from "components/common";

function FooterCom() {
  const footerData = [
    {
      id: 1,
      image: bluelogo,
      text: `enterapp.io \n project by \n entyLabs S.r.o \n Czech Republic, Europe`,
    },
    {
      id: 1,
      image: cnb,
      text: `The Financial Abalytical Office (fAU) \n Czech National Bank (CNB)`,
    },
    {
      id: 1,
      image: fau,
      text: `Virtual Assets VASP License \n Trade Licensing Register (TLR)`,
    },
  ];
  return (
    <FooterWrapper>
      <MainContainer>
        <MainRow>
          <MainCol lg={4}>
            {footerData.map((item, index) => (
              <FooterImgWrapper>
                <MainRow>
                  <MainCol lg={3}>
                    {index > 0 && <Image src={item.image} />}
                  </MainCol>
                  <MainCol lg={9}>
                    {index == 0 && <Image src={item.image} />}
                    <LeftDivText className={index == 0 && "margin-top"}>
                      {item.text}
                    </LeftDivText>
                  </MainCol>
                </MainRow>
              </FooterImgWrapper>
            ))}
          </MainCol>
          <MainCol lg={5}>
            <LinksWrapper>
              <LinksDiv>
                <FooterLinksHeader>Project</FooterLinksHeader>
                <FooterLinks className="first-link">Home</FooterLinks>
                <FooterLinks>About</FooterLinks>
                <FooterLinks>Feature</FooterLinks>
                <FooterLinks>Tokenomics</FooterLinks>
              </LinksDiv>
              <LinksDiv>
                <FooterLinksHeader>Technical</FooterLinksHeader>
                <FooterLinks className="first-link">Roadmap</FooterLinks>
                <FooterLinks>Docs</FooterLinks>
                <FooterLinks> WhitePapers </FooterLinks>
                <FooterLinks>FAQs</FooterLinks>
              </LinksDiv>
            </LinksWrapper>
          </MainCol>
          <MainCol lg={3}>
            <FooterLinksHeader className="last-text">
              Stay Connected-and be our fan:
            </FooterLinksHeader>
            <SocialIconsWrapper>
              <SocialIconHolder>
                <FaLinkedin className="icon" />
              </SocialIconHolder>
              <SocialIconHolder>
                <FaYoutube className="icon" />
              </SocialIconHolder>
              <SocialIconHolder>
                <FaFacebookF className="icon" />
              </SocialIconHolder>
              <SocialIconHolder>
                <FaTwitter className="icon" />
              </SocialIconHolder>
            </SocialIconsWrapper>
            <div className="btn-div">
              <DarkButton btnText="Presale" />
            </div>
          </MainCol>
        </MainRow>
        <BottomLinksWrapper>
          <BottomLinks>Disclaimer</BottomLinks>
          <BottomLinks>terms of services</BottomLinks>
          <BottomLinks>Private policy</BottomLinks>
        </BottomLinksWrapper>
      </MainContainer>
    </FooterWrapper>
  );
}

export default FooterCom;
